<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h4>Nova Franquia</h4>
			<form (keypress)="ocultarMensagem()" (ngSubmit)="f.form.valid && salvar()" #f="ngForm" name="form"
				novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="col-12 md:col-12">
							<h5>Dados Principais</h5>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="nomeFantasia">Nome Franquia</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Digite o nome da Franquia" name="nomeFantasia" ngModel #nomeFantasia="ngModel"
								required />
						</div>
						<div class="field col-12 md:col-5">
							<label htmlFor="razaoSocial">Razão Social*</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Digite a Razão Social" name="razaoSocial" ngModel #razaoSocial="ngModel"
								required />
							<div *ngIf="razaoSocial.hasError('required') && razaoSocial.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="cnpj">CNPJ</label>
							<p-inputMask mask="99.999.999/9999-99" [unmask]="true" type="text"
								placeholder="00.000.000/0000-00" name="cnpj" ngModel #cnpj="ngModel"
								(onBlur)="buscarCnpjFranqui()" [required]="true"> </p-inputMask>
							<div *ngIf="cnpjEncontrado" class="alerta">
								<small>CNPJ Informado já existe</small>
							</div>
						</div>

						<div class="field col-12 md:col-4">
							<label htmlFor="email">E-mail</label>
							<input pInputText type="email" placeholder="seuemail@mail.com" name="email" ngModel
								email="true" #email="ngModel" />
							<div *ngIf="email.hasError('email')" class="alerta">
								<small>Digite um e-mail válido</small>
							</div>
						</div>


						<div class="col-12 md:col-12">
							<h5>Endereço</h5>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="cep">CEP</label>
							<p-inputMask mask="99999-999" [unmask]="true" placeholder="00000-000" name="cep" ngModel
								#cep="ngModel" (onBlur)="consultarCep()"> </p-inputMask>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="logradouro">Logradouro</label>
							<input #inputLogradouro oninput="this.value = this.value.toUpperCase();" pInputText
								type="text" name="logradouro" ngModel #logradouro="ngModel"
								[(ngModel)]="enderecoCep.endereco" (ngModelChange)="camposPreenchendo()"
								[autofocus]="focoCampo" />
							<div *ngIf="exibirMensagemCep" class="alerta">
								<small>Logradouro não encontrado</small>
							</div>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="bairro">Bairro</label>
							<input pInputText type="text" name="bairro" ngModel
								oninput="this.value = this.value.toUpperCase();" (ngModelChange)="camposPreenchendo()"
								[(ngModel)]="enderecoCep.bairro" #bairro="ngModel" />
							<div *ngIf="exibirMensagemCep" class="alerta">
								<small>Bairro não encontrado</small>
							</div>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="numero">Número</label>
							<input pInputText type="text" name="numero" ngModel #numero="ngModel"
								[disabled]="bloqueiaNumeroEComplemento" />
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="complemento">Complemento</label>
							<input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
								name="complemento" ngModel #complemento="ngModel"
								[disabled]="bloqueiaNumeroEComplemento" />
						</div>
						<div class="field col-12 md:col-2" *ngIf="!trocarCamposEndereco">
							<label htmlFor="uf">Estado</label>
							<p-dropdown [options]="listaUfs" optionLabel="siglaUf" [editable]="true" [filter]="true"
								emptyFilterMessage="Nenhum registro" (onChange)="listarMunicipios()" placeholder="UF"
								name="uf" ngModel #uf="ngModel" [(ngModel)]="ufSelecionado"
								[disabled]="bloquearCamposEndereco"></p-dropdown>

							<div *ngIf="exibirMensagemCep" class="alerta">
								<small>UF não encontrado</small>
							</div>
						</div>
						<div class="field col-12 md:col-2" *ngIf="trocarCamposEndereco">
							<label htmlFor="uf">Estado</label>
							<input pInputText type="text" ngModel name="ufs" [(ngModel)]="enderecoCep.estado"
								#uf="ngModel" [disabled]="bloquearCamposEndereco" />
						</div>

						<div class="field col-12 md:col-7" *ngIf="!trocarCamposEndereco">
							<label htmlFor="cidade">Cidade</label>
							<p-dropdown [options]="listaMunicipios" [disabled]="!isUfSelecionada"
								optionLabel="descricao" [editable]="true" [filter]="true"
								emptyFilterMessage="Nenhum registro" placeholder="Selecione a Cidade" name="cidade"
								ngModel #cidade="ngModel" [(ngModel)]="municipioSelecionado"></p-dropdown>
							<div *ngIf="exibirMensagemCep" class="alerta">
								<small>Cidade não encontrada</small>
							</div>
						</div>

						<div class="field col-12 md:col-3" *ngIf="trocarCamposEndereco">
							<label htmlFor="cidade">Cidade</label>
							<input pInputText type="text" name="cidade" ngModel [(ngModel)]="enderecoCep.cidade"
								#cidade="ngModel" [disabled]="bloquearCamposEndereco" />
						</div>

						<div class="col-12 md:col-12">
							<h5>Contatos</h5>
						</div>

						<div class="field col-12 md:col-3">
							<label htmlFor="telefone">Telefone</label>
							<p-inputMask mask="(99)9999-9999" [unmask]="true" type="text" placeholder="(00)0000-0000"
								name="telefone" ngModel #telefone="ngModel"> </p-inputMask>
						</div>

						<div class="field col-12 md:col-3">
							<label htmlFor="whatsapp">Whatsapp</label>
							<p-inputMask mask="(99)99999-9999" [unmask]="true" type="text" placeholder="(00)00000-0000"
								name="whatsapp" ngModel #whatsapp="ngModel"> </p-inputMask>
						</div>

					</div>
					<div class="p-fluid p-formgrid grid justify-content-between">
						<div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
							<button type="submit" pButton icon="pi pi-check" label="Salvar"
								class="p-button-success mt-5" [disabled]="!f.valid || cnpjEncontrado"></button>
						</div>
						<div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
							<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Salvando..."
								class="p-button-success mt-5" [disabled]="true"></button>
						</div>
						<div class="field col-12 md:col-2">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" routerLink="/rfarias/administradora"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>